export const toiOfflineOnlineCitys = [
    {
     "TCI_Both_Offline_Online": "Patna"
    },
    {
     "TCI_Both_Offline_Online": "Jaipur"
    },
    {
     "TCI_Both_Offline_Online": "Indore"
    },
    {
     "TCI_Both_Offline_Online": "Lucknow"
    },
    {
     "TCI_Both_Offline_Online": "Bengaluru"
    },
    {
     "TCI_Both_Offline_Online": "Meerut"
    },
    {
     "TCI_Both_Offline_Online": "Bhopal"
    },
    {
     "TCI_Both_Offline_Online": "Coimbatore"
    },
    {
     "TCI_Both_Offline_Online": "Chennai"
    },
    {
     "TCI_Both_Offline_Online": "Kolkata"
    }
   ]